// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {

}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #ba1718;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.form-label {
  color: #777771;
  font-weight: 600;
  margin-bottom: 0.25rem;
  text-transform: capitalize;
}

.custom-select {
  display: block;
  width: 100%;
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
.custom-select:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);
}
.custom-select::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.custom-select:-ms-input-placeholder {
  color: #999;
}
.custom-select::-webkit-input-placeholder {
  color: #999;
}
.custom-select::-ms-expand {
  background-color: transparent;
  border: 0;
}
.custom-select[disabled],
.custom-select[readonly],
fieldset[disabled] .custom-select {
  background-color: #eee;
  opacity: 1;
}
.custom-select[disabled],
fieldset[disabled] .custom-select {
  cursor: not-allowed;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}




.navbar-collapse.collapsing {
  position: absolute !important;
}

.navbar-collapse li a {
  font-weight: bolder !important;
  padding: 2px 18px !important;
  text-decoration: none;
  text-transform: uppercase;  
}

.x-to-close { display: none; }
.navbar-toggler {
  background: white !important;
}

.navbar-brand img {
  width: 120px !important;
}

@media screen and (max-width: 992px) {
  .x-to-close { display: block; 
    position: absolute;
    right: -53px;
    padding: 20px;
    top: 0;
    background: #dd3e3e;
    color: #ffffff;
  }
  .navbar-collapse {
    position: absolute;
    top: 0px;
    background: #dd3e3e;
    left: 0px;
    padding: 2rem 10px;
    color: #ffffff;
    min-height: 100vh;
    border-right: 2px solid #ffffff ;
  }
  .navbar-collapse li a {
    background: transparent;
    padding: 20px 50px 20px 40px !important;
    font-size: 16px;
    color: #ffffff !important;
    display: inline-block;
    width: 100%;
  }

  .navbar-collapse li a .nav li a {
  padding: 10px 50px 10px 40px !important;
  font-weight: 400;
}

  .navbar-toggler {
    order: 1;
  }
  .navbar-brand {
    order: 2;
    margin-left: 0.5rem;
    margin-right: 0.5rem !important;
    flex-grow: 2;
    max-width: 55%;
  }
  .dropdown  {
    order: 3;
  }


  .navbar-toggler-icon {
    width: 1em !important;
    height: 1em !important;
  }
}

@media screen and (max-width: 576px) {
  .navbar-brand img {
    max-width: 100%;
    width: auto !important;
  }
}

.navbar-toggler {
  border: 0px solid transparent;
}


.navbar {  
  background-repeat: repeat-y;
  background-size: contain;
}

#apus-footer {
  padding: 0.5rem 0;
}

.lightblu {
  color: #53b8e2;
}
.lightblu-contrast {
  color: #53b8e2;
  text-shadow: 0px 0px 1px #164d6c4f;
}

.navbar-nav .nav-link {
  margin: 0 2px;
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #eee;
  opacity: 1;
}


.navbar-expand-lg {
  flex-flow: row nowrap;
  justify-content: space-around;
}

.page-title > svg {
  margin-bottom: -5px;
}
.page-title {
  margin: 1.5rem 0;
}

.btn-outline {
  border-width: 2px;
}


.text-danger {
  background: #dc35451a;
}

.dropdown-menu-right {
  position: absolute;
  will-change: transform;
  top: 0px !important; 
  left: -200% !important; 
}



.compressed-calendar .fc-daygrid-event {
  display: none;  
}

.compressed-calendar .fc-daygrid-day-events {
  position: relative;
}

.compressed-calendar .fc-daygrid-day-events::after {
  content: '';
}

.compressed-calendar .fc-daygrid-day-events {
  min-height: 0 !important;
}

.page-title > .svg-inline--fa{
  color: #d9534f
}

.fc-daygrid-event-dot {
  border-color: #d9534f;
}
/* 
.btn-outline-primary .svg-inline--fa{
  color:#48a65c
}
.btn-outline-primary:hover .svg-inline--fa{
  color:#ffffff
}
.btn-outline-primary.disabled:hover .svg-inline--fa{
  color:#48a65c
} */

.fc-daygrid-event {
  white-space: normal;
}


.fc .fc-button {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0;

  display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    user-select: none;
    border: 0 solid transparent;
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0;
    color: #fff;
    background-color: #434A60;
    border-color: #434A60;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.fc .fc-button-primary:disabled {
  background-color: #434A60;
}

.fc .fc-button-primary:hover {
  background-color: #434A60;
  border-color: #434A60;
  color: #fff;
}

.fc .fc-daygrid-day.fc-day-today {
  background-color: rgb(233 236 239);
}
.fc .fc-daygrid-day.fc-day-today a  {
  color: #212529;
}

.header-container .page-title {
  width: 100%;
}

/* From Uiverse.io by barisdogansutcu */ 
.svgcircle {
  width: 1.5rem;
  transform-origin: center;
  animation: rotate4 2s linear infinite;
 }
 
 circle {
  fill: none;
  stroke: hsl(0, 0%, 0%);
  stroke-width: 4;
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: dash4 1.5s ease-in-out infinite;
 }
 
 @keyframes rotate4 {
  100% {
   transform: rotate(360deg);
  }
 }
 
 @keyframes dash4 {
  0% {
   stroke-dasharray: 1, 200;
   stroke-dashoffset: 0;
  }
 
  50% {
   stroke-dasharray: 90, 200;
   stroke-dashoffset: -35px;
  }
 
  100% {
   stroke-dashoffset: -125px;
  }
 }






 .bg-danger > * {
  color: white !important;
 }
 

.my-form-survey input[type="checkbox"]:checked {
  accent-color: #E63839 !important; /* blu primario di bootstrap, puoi cambiare */
}

/* Opzionale: bordo checkbox */
.my-form-survey input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

.imu-widget { 
  max-width: 640px; 
  margin: 20px auto; 
  border-radius: 14px; 
}

.imu-result { 
  border-radius: 10px;
 } 
 
 details summary { 
  cursor: pointer;
 }

 .btn-red {
  background-color: #d9534f;; /* rosso bootstrap */
  border-color: #dc3545;
  color: white;
}

 .btn-red:hover{
  background-color: #d23430; /* rosso bootstrap */
  border-color: #c9302c;
    color: white;
}

  .simulatore-root { font-family: system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,'Helvetica Neue',Arial;  }
  .simulatore-root h1 { font-size: 22px; margin: 0 0 12px; }
  .simulatore-fieldset { border: 1px solid #ddd; padding: 12px; margin: 12px 0; border-radius: 8px; }
  .simulatore-legend { padding: 0 6px; color: #444; font-weight: 600; }
  .simulatore-label { display: block; margin: 6px 0; }
  .simulatore-row { display:flex; gap:16px; flex-wrap: wrap; }
  .simulatore-col { flex:1 1 260px; }
  .simulatore-num { width: 140px; }
  .simulatore-pill { display:inline-block; border:1px solid #aaa; border-radius:999px; padding:2px 10px; margin:2px 4px; font-size:12px; }
  .simulatore-badge { background:#eef; padding:2px 8px; border-radius:6px; border:1px solid #cce; }
  .simulatore-muted { color:#666; font-size:12px; }
  .simulatore-out { background:#f9fafb; border:1px dashed #ccd; padding:12px; border-radius:8px; margin-top:8px; }
  .simulatore-btn { padding:10px 14px; border:0;  background:#d23430; color:#fff; cursor:pointer; }
  .simulatore-btn:disabled { background:#aaa; }
  .simulatore-note { font-size:12px; color:#444; }
  /* .simulatore-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); gap:8px; }
   */

   .simulatore-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); /* 🔹 crea 2 righe flessibili */
  gap: 12px 20px; /* 🔹 spaziatura verticale e orizzontale */
  align-items: center;
}

.simulatore-label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px; /* 🔹 spazio tra testo e input/select */
  white-space: nowrap; /* evita che il testo vada a capo */
  font-size: 0.95rem;
}

.simulatore-label select,
.simulatore-label input[type="checkbox"] {
  margin-left: 6px;
}
  .simulatore-hl { background:#fffbdd; }

  .simulatore-grid-2col {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

/* Due colonne solo su schermi larghi */
@media (min-width: 768px) {
  .simulatore-grid-2col {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,mCAAmC;EACnC,4BAA4B;EAC5B,2DAA2D;EAC3D,sCAAsC;EACtC,sEAAsE;AACxE;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,SAAS;AACX;AACA;;;EAGE,sBAAsB;EACtB,UAAU;AACZ;AACA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;;;;AAKA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,cAAc,aAAa,EAAE;AAC7B;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc,cAAc;IAC1B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,MAAM;IACN,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gCAAgC;EAClC;EACA;IACE,uBAAuB;IACvB,uCAAuC;IACvC,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;EACb;;EAEA;EACA,uCAAuC;EACvC,gBAAgB;AAClB;;EAEE;IACE,QAAQ;EACV;EACA;IACE,QAAQ;IACR,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;IACZ,cAAc;EAChB;EACA;IACE,QAAQ;EACV;;;EAGA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,sBAAsB;EACtB,UAAU;AACZ;;;AAGA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;;;AAIA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;AACvB;AACA;;;;;;;;;GASG;;AAEH;EACE,mBAAmB;AACrB;;;AAGA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;;EAEhB,qBAAqB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,qIAAqI;AACzI;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,wBAAwB;EACxB,qCAAqC;CACtC;;CAEA;EACC,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,0CAA0C;CAC3C;;CAEA;EACC;GACC,yBAAyB;EAC1B;CACD;;CAEA;EACC;GACC,wBAAwB;GACxB,oBAAoB;EACrB;;EAEA;GACC,yBAAyB;GACzB,wBAAwB;EACzB;;EAEA;GACC,yBAAyB;EAC1B;CACD;;;;;;;CAOA;EACC,uBAAuB;CACxB;;;AAGD;EACE,gCAAgC,EAAE,6CAA6C;AACjF;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;CACpB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,yBAAyB,GAAG,oBAAoB;EAChD,qBAAqB;EACrB,YAAY;AACd;;CAEC;EACC,yBAAyB,EAAE,oBAAoB;EAC/C,qBAAqB;IACnB,YAAY;AAChB;;EAEE,mBAAmB,4FAA4F,GAAG;EAClH,sBAAsB,eAAe,EAAE,gBAAgB,EAAE;EACzD,uBAAuB,sBAAsB,EAAE,aAAa,EAAE,cAAc,EAAE,kBAAkB,EAAE;EAClG,qBAAqB,cAAc,EAAE,WAAW,EAAE,gBAAgB,EAAE;EACpE,oBAAoB,cAAc,EAAE,aAAa,EAAE;EACnD,kBAAkB,YAAY,EAAE,QAAQ,EAAE,eAAe,EAAE;EAC3D,kBAAkB,cAAc,EAAE;EAClC,kBAAkB,YAAY,EAAE;EAChC,mBAAmB,oBAAoB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE;EACvI,oBAAoB,eAAe,EAAE,eAAe,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;EAChG,oBAAoB,UAAU,EAAE,cAAc,EAAE;EAChD,kBAAkB,kBAAkB,EAAE,sBAAsB,EAAE,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;EAC/G,kBAAkB,iBAAiB,EAAE,QAAQ,GAAG,kBAAkB,EAAE,UAAU,EAAE,cAAc,EAAE;EAChG,2BAA2B,eAAe,EAAE;EAC5C,mBAAmB,cAAc,EAAE,UAAU,EAAE;EAC/C;IACE;;GAED;EACD,aAAa;EACb,4DAA4D,EAAE,+BAA+B;EAC7F,cAAc,EAAE,0CAA0C;EAC1D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ,EAAE,uCAAuC;EACjD,mBAAmB,EAAE,mCAAmC;EACxD,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;EACE,iBAAiB,kBAAkB,EAAE;;EAErC;EACA,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA,uCAAuC;AACvC;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".App {\n\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #ba1718;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.form-label {\n  color: #777771;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n  text-transform: capitalize;\n}\n\n.custom-select {\n  display: block;\n  width: 100%;\n  padding: .375rem .75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-clip: padding-box;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n.custom-select:focus {\n  color: var(--bs-body-color);\n  background-color: var(--bs-body-bg);\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);\n}\n.custom-select::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n.custom-select:-ms-input-placeholder {\n  color: #999;\n}\n.custom-select::-webkit-input-placeholder {\n  color: #999;\n}\n.custom-select::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.custom-select[disabled],\n.custom-select[readonly],\nfieldset[disabled] .custom-select {\n  background-color: #eee;\n  opacity: 1;\n}\n.custom-select[disabled],\nfieldset[disabled] .custom-select {\n  cursor: not-allowed;\n}\n\n.header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n\n\n\n.navbar-collapse.collapsing {\n  position: absolute !important;\n}\n\n.navbar-collapse li a {\n  font-weight: bolder !important;\n  padding: 2px 18px !important;\n  text-decoration: none;\n  text-transform: uppercase;  \n}\n\n.x-to-close { display: none; }\n.navbar-toggler {\n  background: white !important;\n}\n\n.navbar-brand img {\n  width: 120px !important;\n}\n\n@media screen and (max-width: 992px) {\n  .x-to-close { display: block; \n    position: absolute;\n    right: -53px;\n    padding: 20px;\n    top: 0;\n    background: #dd3e3e;\n    color: #ffffff;\n  }\n  .navbar-collapse {\n    position: absolute;\n    top: 0px;\n    background: #dd3e3e;\n    left: 0px;\n    padding: 2rem 10px;\n    color: #ffffff;\n    min-height: 100vh;\n    border-right: 2px solid #ffffff ;\n  }\n  .navbar-collapse li a {\n    background: transparent;\n    padding: 20px 50px 20px 40px !important;\n    font-size: 16px;\n    color: #ffffff !important;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .navbar-collapse li a .nav li a {\n  padding: 10px 50px 10px 40px !important;\n  font-weight: 400;\n}\n\n  .navbar-toggler {\n    order: 1;\n  }\n  .navbar-brand {\n    order: 2;\n    margin-left: 0.5rem;\n    margin-right: 0.5rem !important;\n    flex-grow: 2;\n    max-width: 55%;\n  }\n  .dropdown  {\n    order: 3;\n  }\n\n\n  .navbar-toggler-icon {\n    width: 1em !important;\n    height: 1em !important;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .navbar-brand img {\n    max-width: 100%;\n    width: auto !important;\n  }\n}\n\n.navbar-toggler {\n  border: 0px solid transparent;\n}\n\n\n.navbar {  \n  background-repeat: repeat-y;\n  background-size: contain;\n}\n\n#apus-footer {\n  padding: 0.5rem 0;\n}\n\n.lightblu {\n  color: #53b8e2;\n}\n.lightblu-contrast {\n  color: #53b8e2;\n  text-shadow: 0px 0px 1px #164d6c4f;\n}\n\n.navbar-nav .nav-link {\n  margin: 0 2px;\n}\n\n\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\n  background-color: #eee;\n  opacity: 1;\n}\n\n\n.navbar-expand-lg {\n  flex-flow: row nowrap;\n  justify-content: space-around;\n}\n\n.page-title > svg {\n  margin-bottom: -5px;\n}\n.page-title {\n  margin: 1.5rem 0;\n}\n\n.btn-outline {\n  border-width: 2px;\n}\n\n\n.text-danger {\n  background: #dc35451a;\n}\n\n.dropdown-menu-right {\n  position: absolute;\n  will-change: transform;\n  top: 0px !important; \n  left: -200% !important; \n}\n\n\n\n.compressed-calendar .fc-daygrid-event {\n  display: none;  \n}\n\n.compressed-calendar .fc-daygrid-day-events {\n  position: relative;\n}\n\n.compressed-calendar .fc-daygrid-day-events::after {\n  content: '';\n}\n\n.compressed-calendar .fc-daygrid-day-events {\n  min-height: 0 !important;\n}\n\n.page-title > .svg-inline--fa{\n  color: #d9534f\n}\n\n.fc-daygrid-event-dot {\n  border-color: #d9534f;\n}\n/* \n.btn-outline-primary .svg-inline--fa{\n  color:#48a65c\n}\n.btn-outline-primary:hover .svg-inline--fa{\n  color:#ffffff\n}\n.btn-outline-primary.disabled:hover .svg-inline--fa{\n  color:#48a65c\n} */\n\n.fc-daygrid-event {\n  white-space: normal;\n}\n\n\n.fc .fc-button {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0;\n\n  display: inline-block;\n    font-weight: 400;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    user-select: none;\n    border: 0 solid transparent;\n    padding: 0.75rem 1.5rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: 0;\n    color: #fff;\n    background-color: #434A60;\n    border-color: #434A60;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.fc .fc-button-primary:disabled {\n  background-color: #434A60;\n}\n\n.fc .fc-button-primary:hover {\n  background-color: #434A60;\n  border-color: #434A60;\n  color: #fff;\n}\n\n.fc .fc-daygrid-day.fc-day-today {\n  background-color: rgb(233 236 239);\n}\n.fc .fc-daygrid-day.fc-day-today a  {\n  color: #212529;\n}\n\n.header-container .page-title {\n  width: 100%;\n}\n\n/* From Uiverse.io by barisdogansutcu */ \n.svgcircle {\n  width: 1.5rem;\n  transform-origin: center;\n  animation: rotate4 2s linear infinite;\n }\n \n circle {\n  fill: none;\n  stroke: hsl(0, 0%, 0%);\n  stroke-width: 4;\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  animation: dash4 1.5s ease-in-out infinite;\n }\n \n @keyframes rotate4 {\n  100% {\n   transform: rotate(360deg);\n  }\n }\n \n @keyframes dash4 {\n  0% {\n   stroke-dasharray: 1, 200;\n   stroke-dashoffset: 0;\n  }\n \n  50% {\n   stroke-dasharray: 90, 200;\n   stroke-dashoffset: -35px;\n  }\n \n  100% {\n   stroke-dashoffset: -125px;\n  }\n }\n\n\n\n\n\n\n .bg-danger > * {\n  color: white !important;\n }\n \n\n.my-form-survey input[type=\"checkbox\"]:checked {\n  accent-color: #E63839 !important; /* blu primario di bootstrap, puoi cambiare */\n}\n\n/* Opzionale: bordo checkbox */\n.my-form-survey input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin-right: 8px;\n}\n\n.imu-widget { \n  max-width: 640px; \n  margin: 20px auto; \n  border-radius: 14px; \n}\n\n.imu-result { \n  border-radius: 10px;\n } \n \n details summary { \n  cursor: pointer;\n }\n\n .btn-red {\n  background-color: #d9534f;; /* rosso bootstrap */\n  border-color: #dc3545;\n  color: white;\n}\n\n .btn-red:hover{\n  background-color: #d23430; /* rosso bootstrap */\n  border-color: #c9302c;\n    color: white;\n}\n\n  .simulatore-root { font-family: system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,'Helvetica Neue',Arial;  }\n  .simulatore-root h1 { font-size: 22px; margin: 0 0 12px; }\n  .simulatore-fieldset { border: 1px solid #ddd; padding: 12px; margin: 12px 0; border-radius: 8px; }\n  .simulatore-legend { padding: 0 6px; color: #444; font-weight: 600; }\n  .simulatore-label { display: block; margin: 6px 0; }\n  .simulatore-row { display:flex; gap:16px; flex-wrap: wrap; }\n  .simulatore-col { flex:1 1 260px; }\n  .simulatore-num { width: 140px; }\n  .simulatore-pill { display:inline-block; border:1px solid #aaa; border-radius:999px; padding:2px 10px; margin:2px 4px; font-size:12px; }\n  .simulatore-badge { background:#eef; padding:2px 8px; border-radius:6px; border:1px solid #cce; }\n  .simulatore-muted { color:#666; font-size:12px; }\n  .simulatore-out { background:#f9fafb; border:1px dashed #ccd; padding:12px; border-radius:8px; margin-top:8px; }\n  .simulatore-btn { padding:10px 14px; border:0;  background:#d23430; color:#fff; cursor:pointer; }\n  .simulatore-btn:disabled { background:#aaa; }\n  .simulatore-note { font-size:12px; color:#444; }\n  /* .simulatore-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); gap:8px; }\n   */\n\n   .simulatore-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); /* 🔹 crea 2 righe flessibili */\n  gap: 12px 20px; /* 🔹 spaziatura verticale e orizzontale */\n  align-items: center;\n}\n\n.simulatore-label {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px; /* 🔹 spazio tra testo e input/select */\n  white-space: nowrap; /* evita che il testo vada a capo */\n  font-size: 0.95rem;\n}\n\n.simulatore-label select,\n.simulatore-label input[type=\"checkbox\"] {\n  margin-left: 6px;\n}\n  .simulatore-hl { background:#fffbdd; }\n\n  .simulatore-grid-2col {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n}\n\n/* Due colonne solo su schermi larghi */\n@media (min-width: 768px) {\n  .simulatore-grid-2col {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
